module.exports = __webpack_public_path__ + "img/4.75b3a5bf.png";